import React from 'react';

function Speaker() {
  return (
    <>
      <path
        d="M377.657 261.895C377.657 263.554 376.312 264.9 374.652 264.9C372.992 264.9 371.647 263.554 371.647 261.895C371.647 260.235 372.992 258.89 374.652 258.89C376.312 258.89 377.657 260.235 377.657 261.895Z"
        fill="#030303"
      />
      <path
        d="M389.2 261.895C389.2 263.554 387.855 264.9 386.195 264.9C384.536 264.9 383.19 263.554 383.19 261.895C383.19 260.235 384.536 258.89 386.195 258.89C387.855 258.89 389.2 260.235 389.2 261.895Z"
        fill="#030303"
      />
      <path
        d="M401.125 261.895C401.125 263.554 399.779 264.9 398.12 264.9C396.46 264.9 395.115 263.554 395.115 261.895C395.115 260.235 396.46 258.89 398.12 258.89C399.779 258.89 401.125 260.235 401.125 261.895Z"
        fill="#030303"
      />
      <path
        d="M412.763 261.895C412.763 263.554 411.418 264.9 409.758 264.9C408.098 264.9 406.753 263.554 406.753 261.895C406.753 260.235 408.098 258.89 409.758 258.89C411.418 258.89 412.763 260.235 412.763 261.895Z"
        fill="#030303"
      />
      <path
        d="M424.401 261.895C424.401 263.554 423.056 264.9 421.397 264.9C419.737 264.9 418.392 263.554 418.392 261.895C418.392 260.235 419.737 258.89 421.397 258.89C423.056 258.89 424.401 260.235 424.401 261.895Z"
        fill="#030303"
      />
      <path
        d="M383.19 270.385C383.19 272.045 381.845 273.39 380.185 273.39C378.526 273.39 377.18 272.045 377.18 270.385C377.18 268.725 378.526 267.38 380.185 267.38C381.845 267.38 383.19 268.725 383.19 270.385Z"
        fill="#030303"
      />
      <path
        d="M395.21 270.385C395.21 272.045 393.865 273.39 392.205 273.39C390.545 273.39 389.2 272.045 389.2 270.385C389.2 268.725 390.545 267.38 392.205 267.38C393.865 267.38 395.21 268.725 395.21 270.385Z"
        fill="#030303"
      />
      <path
        d="M407.134 270.385C407.134 272.045 405.789 273.39 404.13 273.39C402.47 273.39 401.125 272.045 401.125 270.385C401.125 268.725 402.47 267.38 404.13 267.38C405.789 267.38 407.134 268.725 407.134 270.385Z"
        fill="#030303"
      />
      <path
        d="M419.142 270.385C419.142 272.045 417.797 273.39 416.137 273.39C414.478 273.39 413.132 272.045 413.132 270.385C413.132 268.725 414.478 267.38 416.137 267.38C417.797 267.38 419.142 268.725 419.142 270.385Z"
        fill="#030303"
      />
      <path
        d="M389.2 278.875C389.2 280.535 387.855 281.881 386.195 281.881C384.536 281.881 383.19 280.535 383.19 278.875C383.19 277.216 384.536 275.87 386.195 275.87C387.855 275.87 389.2 277.216 389.2 278.875Z"
        fill="#030303"
      />
      <path
        d="M401.125 278.875C401.125 280.535 399.779 281.881 398.12 281.881C396.46 281.881 395.115 280.535 395.115 278.875C395.115 277.216 396.46 275.87 398.12 275.87C399.779 275.87 401.125 277.216 401.125 278.875Z"
        fill="#030303"
      />
      <path
        d="M413.145 278.875C413.145 280.535 411.799 281.881 410.14 281.881C408.48 281.881 407.135 280.535 407.135 278.875C407.135 277.216 408.48 275.87 410.14 275.87C411.799 275.87 413.145 277.216 413.145 278.875Z"
        fill="#030303"
      />
    </>
  );
}

export default Speaker;
